import { useMemo } from 'react';

import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { SearchProps } from 'antd/es/input';
import { debounce } from 'lodash-es';

const { Search, TextArea } = Input;

interface Props extends SearchProps {
  delayTime?: number;
  onSearchChange?: (value: string) => void;
  onSearch?: (value: string) => void;
  searchRef?: React.RefObject<any>;
  value?: string;
}

const SearchComponent: React.FC<Props> = ({ onSearchChange, searchRef, ...props }) => {
  const { onSearch, delayTime } = props;
  const debouncedChange = useMemo(
    () =>
      debounce((value: string) => {
        onSearch?.(value);
        onSearchChange?.(value);
      }, delayTime || 500),
    [onSearch, delayTime, onSearchChange],
  );

  return (
    <Input
      {...props}
      prefix={<SearchOutlined />}
      ref={searchRef}
      value={props.value}
      onChange={(e) => {
        props.onChange?.(e);
        debouncedChange(e.target.value);
      }}
    />
  );
};

export { SearchComponent as Search, TextArea };

export default Input;
